import { Tag } from "primereact/tag";

interface EnabledTagProps {
  enabled?: boolean;
}

/**
 * Enabled/disabled indicator for certificate rows. Read-only everywhere it is used: the
 * only toggle endpoint (PATCH /rest/opcua/users/{username}/enabled) is documented for
 * username/password accounts, not certificate identities.
 */
const EnabledTag = ({ enabled }: EnabledTagProps) => (
  <Tag
    value={enabled ? "Yes" : "No"}
    severity={enabled ? "success" : "danger"}
  />
);

export default EnabledTag;
